import standardAPI from '@/api/standard_items';

const state = {
  agents: [],
  agents_status: '',
  agents_search_status: '',
  agents_MetaData: {},
  agents_page: 1,
  agents_perPage: 10,
};

const responseUrl = '/agents';

const getters = {};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_agents ({ commit }, getOptions) {
    commit('AGENTS_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('AGENTS_SUCCESS', response);
            commit('AGENTS_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('AGENTS_READY');
            reject(response);
          } else {
            commit('AGENTS_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  fetch_query_agents ({ commit }, getOptions) {
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        if (response && response.data) {
          resolve(response);
        } else {
          reject(response);
        }
      }, preparedOptions);
    });
  },
  add_agent ({ commit, dispatch }, itemData) {
    commit('AGENTS_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          commit('AGENTS_READY');
          resolve(response);
        } else {
          commit('AGENTS_READY');
          reject(response);
        }
      });
    });
  },
  edit_agent ({ commit, dispatch }, itemData) {
    commit('AGENTS_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          commit('AGENTS_READY');
          resolve(response);
        } else {
          commit('AGENTS_READY');
          reject(response);
        }
      });
    });
  },
  remove_agent ({ commit, dispatch }, itemData) {
    commit('AGENTS_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          commit('AGENTS_READY');
          resolve();
        } else {
          commit('AGENTS_READY');
          reject(response);
        }
      });
    });
  },
  reorder_agent ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData: orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.agents_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.agents_perPage = max;
  },
  AGENTS_READY: (state) => {
    state.agents_status = 'ready';
  },
  AGENTS_REQUEST: (state) => {
    state.agents_status = 'loading';
  },
  AGENTS_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.agents_MetaData.meta = response.meta;
      state.agents_MetaData.links = response.links;
    }
    state.agents = response.data;
    state.agents_status = 'success';
  },
  AGENTS_ERROR: (state) => {
    state.agents_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
